const catalogacaoLocalize = {
  'need to send a provider to update': 'Selecione um provedor para atualizar',
  cataloging: 'Catalogação'
};

export default catalogacaoLocalize;
